import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Button, HorizontalFormControl, Modal } from '../../../../common/components';
import { SelectField } from '../../../../common/components/ReduxFormField';
import { openModal } from '../../../../common/components/Modal/ModalRedux';
import { actions as sourceActions } from '../../redux/sourceActions';
import { actions as sourceTypeActions } from '../../redux/sourceTypeActions';
import { get, flow, isEmpty, set } from 'lodash';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'react-bootstrap';

const FORM_NAME = 'createSourceForm';

const validate = (values) => {
  const errors = {};

  if (isEmpty(get(values, 'data.attributes.name', ''))) {
    set(errors, 'data.attributes.name', 'Required');
  }

  if (isEmpty(get(values, 'data.attributes.status', ''))) {
    set(errors, 'data.attributes.status', 'Please select a status');
  }
  return errors;
};

class CreateSourceButton extends Component {
  handleSubmit = (values) => {
    const { sourceActions } = this.props;
    return sourceActions.createSource(values);
  };

  handleOpen() {
    const { dispatch, change, sourceTypeActions } = this.props;

    Promise.resolve(sourceTypeActions.setBrokerSourceType()).then((resp) => {
      if (resp && resp.id) {
        dispatch(change('data.relationships.source_type.data.id', resp.id));
        dispatch(openModal(FORM_NAME));
      }
    });
  }

  render() {
    const { label, handleSubmit, submitting, reset, dispatch } = this.props;
    const title = label || 'Create Source';
    const submitButton = (
      <Button
        type="submit"
        bsStyle="primary"
        disabled={submitting}
        isLoading={submitting}
        label="Create Source"
      />
    );

    return (
      <div className="source-btn-wrapper pull-right">
        <Button
          bsStyle="primary"
          label="New Source"
          handleClick={() => this.handleOpen()}
        />

        <Modal
          name={FORM_NAME}
          title={title}
          close={true}
          handleSubmit={handleSubmit(this.handleSubmit)}
          footer={submitButton}
          onHide={() => {
            dispatch(reset());
          }}
        >
          <Row>
            <Col sm={8}>
              <Field
                name={'data.attributes.name'}
                label="Source Name"
                labelSize={2}
                type="textarea"
                component={HorizontalFormControl}
              />
            </Col>

            <Col sm={3}>
              <Field
                name={'data.attributes.status'}
                options={[
                  { label: 'Active', value: 'active' },
                  { label: 'Inactive', value: 'inactive' },
                ]}
                component={SelectField}
              />
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

export default flow([
  reduxForm({
    form: FORM_NAME,
    validate,
  }),
  connect(
    (state, props) => {
      const formValues = getFormValues(FORM_NAME)(state);
      const initialValues = {
        data: {
          relationships: {
            broker: {
              data: {
                id: get(props.broker, 'id', ''),
              },
            },
            source_type: {
              data: {
                id: '',
              },
            },
          },
        },
      };

      return {
        formValues,
        initialValues,
      };
    },
    (dispatch) => ({
      sourceActions: bindActionCreators(sourceActions, dispatch),
      sourceTypeActions: bindActionCreators(sourceTypeActions, dispatch),
      dispatch,
    }),
  ),
])(CreateSourceButton);
